export const useStyles = (theme) => ({
  categoryStyle: {
    padding: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
    },
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 18,
    borderRadius: 20,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up(960)]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up(960)]: {
      display: "none",
    },
  },
  root: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  labelStyle: {
    cursor: "pointer",
    fontSize: 18,
    display: "flex",
    justifyContent: "center",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  linkStyle: {
    textDecoration: "none",
    cursor: "pointer",
    color: "#0a1f3a",
    fontWeight: "bold",
    "&:hover": {
      textDecoration: "underline",
    },
  },
});
